<template>
  <div v-if="data">
    <Top />
    <div class="container container--mobile">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <Pagination :numberOfDots="4" :numberOfVisitedDots="4" />
          <div class="margin-top-75"></div>
          <div class="header-wrapper">
            <h2 class="text-primary-fh left-header" v-html="data.screening.verifycontactheader"></h2>
          </div>
          <div class="clearfix"></div>
          <p v-html="data.screening.verifycontacttext"></p>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix"></div>
          <button
          class="btn btn-primary btn-lg btn-block"
          @click="verifyContact('Ja')">Ja</button>
          <div class="clearfix"></div>
          <button
          class="btn btn-primary btn-lg btn-block"
          @click="verifyContact('Nej')">Nej</button>
          <div class="clearfix"></div>
          <button class="btn btn-outline-dark btn-lg btn-block" @click="$router.go(-1)">&#8592; Tillbaka</button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import Pagination from '../../src/components/Pagination'
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'

export default {
  name: 'verifycontacthospital',
  components: {
    Top,
    Bottom,
    Pagination
  },
  data () {
    return {
      data: null
    }
  },
  methods: {
    verifyContact (_answer) {
      if (_answer !== null) {
        let loader = this.$loading.show()
        if (_answer === 'Ja') {
          axios._post(config.medicalRecordsUri + config.contactRelativeHospitalUri).then((response) => {
            if (response.status === 200) {
              loader.hide()
              if (sessionStorage.getItem('isGeneNegative') === 'true') {
                this.$router.push({
                  name: 'screening',
                  params: { fieldId: '10113375' } // consentjournals
                })
              } else {
                this.$router.push('dashboardnf')
              }
            }
          }, (error) => {
            if (error.response && error.response.status === 401) {
              loader.hide()
              window.location.href = window.location.origin.concat('/error')
            } else {
              loader.hide()
              console.log(error)
            }
          })
        } else {
          loader.hide()
          this.$router.push('errorcontact')
        }
      }
    }
  },
  computed: {},
  beforeMount () {},
  async mounted () {
    this.data = await request({
      query: `
        {
          screening {
            verifycontactheader
            verifycontacttext
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-bottom: 10vh;
  min-height: 60vh;
}
.page-item {
  color: transparent !important;
}
.margin-top-75 {
  margin-top: 75px;
}
.header-wrapper {
  display: flex;
}
.left-header {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/VerifyContactHospital.vue